import { TextButtonLink, TextButtonLinkProps, TextButtonProps, TextButton, tv } from "@/ui";

export type HeaderTextButtonLinkProps = TextButtonLinkProps;

export const HeaderTextButtonLink = ({ className, ...props }: HeaderTextButtonLinkProps) => {
  return <TextButtonLink className={headerTextButtonVariants({ className })} {...props} />;
};

export type HeaderTextButtonProps = TextButtonProps;

export const HeaderTextButton = ({ className, ...props }: HeaderTextButtonProps) => {
  return <TextButton className={headerTextButtonVariants({ className })} {...props} />;
};

const headerTextButtonVariants = tv({
  base: "text-light-primary hover:text-light-primary/80 pressed:text-light-primary/50",
});
